export interface ItemArtSource { slot: string; formId?: string; subtype?: string; id?: number }
const forms: Record<string, Record<string, string>> = {
  main_hand: { sword: 'sword', axe: 'axe', daggers: 'daggers' },
  chest: { light: 'light', leather: 'light', medium: 'medium', mail: 'medium', brigandine: 'medium', heavy: 'heavy', plate: 'heavy', robe: 'robe' },
  head: { cap: 'cap', helmet: 'helmet', crown: 'crown', hood: 'hood', hat: 'hat', circlet: 'crown', mask: 'helmet', coif: 'helmet' },
  feet: { boots: 'boots', shoes: 'boots', greaves: 'feet_greaves', sabatons: 'feet_greaves', sandals: 'sandals' },
  neck: { pendant: 'pendant', amulet: 'amulet', necklace: 'necklace', medallion: 'pendant', talisman: 'amulet' },
  hands: { gloves: 'gloves', gauntlets: 'gauntlets' },
  legs: { leggings: 'leggings', pants: 'leggings', greaves: 'legs_greaves', chausses: 'legs_greaves', tassets: 'legs_greaves' },
  cloak: { cloak: 'cloak', cape: 'cloak', mantle: 'cloak' },
  finger: { ring: 'ring', signet: 'ring', band: 'ring' },
  wrist: { bracers: 'bracers', wristguards: 'bracers', vambraces: 'bracers', bracelet: 'bracers' },
};
export function resolveItemArtFamily(item: ItemArtSource): string | null {
  const form = item.formId?.split('.').pop();
  const choices = forms[item.slot];
  if (!choices) return null;
  if (form) return choices[form] ?? null;
  if (item.subtype) return choices[item.subtype] ?? null;
  return null;
}
export function itemArtVariant(id: number | undefined, count: number): number {
  return count > 0 ? Math.abs(Math.trunc(Number.isFinite(id) ? id! : 0)) % count : 0;
}
